import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { useParams } from "react-router-dom";
import { MEDSTAR_ASSOCIATION_TYPE__CONTRACTOR, MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE, MEDSTAR_ASSOCIATION_TYPE__UNKNOWN } from "../../../sitel/commons/utilities/medstarAssociationType";
import HeaderSection from "./headerSection";
import BasicFormSection from "../../../pageComponents/profilePages/basicFormSection";
import EmploymentInformationSection from "./employmentInformationSection";

import schema from "../../../pageComponents/profilePages/formSchema";
import useFormSubmit from "../../../pageComponents/profilePages/useFormSubmit";
import { TitleWMutedRow } from "../../../sitel/demon/ui/atoms";
import SubmitButton from "../../../sitel/demon/ui/atoms/buttons/SubmitButton";
import ProfileFormModal from "../../../pageComponents/profilePages/profileFormModal";
import { titleText } from "../../../components/utils/medstarAssociationTexts";

export default function Step5Profile() {
	const [submitStatus, setSubmitStatus] = useState('idle');
	const params = useParams();
	const medstarAssociationType = params.medstarAssociationType
	const [showProfileModal, setShowProfileModal] = useState({ showModal: false, success: false,isNewAccount:true })
	const formSchema = schema(medstarAssociationType);
	console.log('FORM SCHEMA',formSchema);
	const { register, handleSubmit, formState: { errors, isSubmitting, isSubmitSuccessful } } = useForm({ resolver: yupResolver(formSchema) });
	const onSubmit = useFormSubmit(medstarAssociationType, setSubmitStatus, showProfileModal, setShowProfileModal, 'new');
	const language = titleText(medstarAssociationType);
	console.log('SELECTED MEDSTAR ASSOCIATION TYPE',medstarAssociationType);

	const needBody = () => {
		// We need to show body section when the medstar_association_type is defines( NOT UNKNOWN). 
		//That means if user's medstar_association_type is still UNKNOWN, do not show body until he selects the proper type(student, contractor, board member,..)
		return medstarAssociationType !== MEDSTAR_ASSOCIATION_TYPE__UNKNOWN;
	}

	return (
		<>
			<TitleWMutedRow muted={language.mutedTitle}>{language.title}</TitleWMutedRow>
			<form onSubmit={handleSubmit(onSubmit)}>
				<HeaderSection medstarAssociationType={medstarAssociationType} register={register} errors={errors} />
						
				{(needBody())
					?
					<>
						<BasicFormSection register={register} errors={errors} />
						<EmploymentInformationSection medstarAssociationType={medstarAssociationType} register={register} errors={errors} />
						<div className="row justify-content-end">
							<div className="col-auto my-1">
								<SubmitButton isSubmitting={isSubmitting} isSubmitSuccessful={isSubmitSuccessful && (!(submitStatus === 'profile-save-failed') && !(submitStatus === 'profile-saved'))} defaultLabel='Create My Account' className="btn-medstar-primary" />
							</div>
						</div>
					</>
					: null

				}
			</form>
			<ProfileFormModal showProfileModal={showProfileModal} setShowProfileModal={setShowProfileModal} />
		</>
	);
}

